// src/viewmodels/useContactViewModel.js
import { useState } from 'react';
import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
emailjs.init('UrYJxUcf-HGDyQYh9');

const initialForm = { name: '', email: '', subject: '', message: '' };

export function useContactViewModel() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState('idle'); // idle | loading | success | error

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    try {
      await emailjs.send(
        'slbf gkpr hszb osxh',
        'template_u65670n',
        {
          to_email: 'mrjabiulla34@gmail.com',
          from_name: form.name,
          from_email: form.email,
          subject: form.subject,
          message: form.message,
        }
      );
      setStatus('success');
      setForm(initialForm);
      setTimeout(() => setStatus('idle'), 4000);
    } catch (error) {
      console.error('Email send failed:', error);
      setStatus('error');
      setTimeout(() => setStatus('idle'), 4000);
    }
  };

  return { form, status, handleChange, handleSubmit };
}
